import React from "react";
import { InputLabel } from "../../../../shared/InputLabel/InputLabel";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { InputPhone as Input } from "../../../../shared/InputPhone/InputPhone";
import { InputError } from "../../../../shared/InputError/InputError";

export function InputPhone({ value, onChange, error, isDisabled = false }) {
  const { tCommon } = useAppTranslation.Common();

  return (
    <div>
      <InputLabel>
        {tCommon("createQualifyProcedure.formLabel.phone")}
      </InputLabel>
      <Input
        fullWidth
        value={value}
        onChange={onChange}
        isError={!!error}
        isDisabled={isDisabled}
      />
      {!!error && <InputError>{error}</InputError>}
      {!value && (
        <InputError>{tCommon("update_via_patient_profile.phone")}</InputError>
      )}
    </div>
  );
}
